exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body.library-reordering,body.library-reordering *{cursor:move!important}", ""]);

// exports
